import { environment } from '../environments/environment';
import developmentSettings from './settings.development.json';
import testSettings from './settings.test.json';
import acceptanceSettings from './settings.acceptance.json';
import productionSettings from './settings.production.json';

const settingsMap = {
  'development': developmentSettings,
  'test': testSettings,
  'acceptance': acceptanceSettings,
  'production': productionSettings
};

export const b2bSettings = settingsMap[environment.name] || developmentSettings;
